import { PageLayout } from '../../PageLayout';
import { OutsideInventoryBulkManualForm } from '../../Compounds/OutsideInventoryForm/OutsideInventoryBulkManualForm';
import { useEffect } from 'react';
import { TextBlock } from '../../Atoms/Text';
import { PermissibleRender } from '../../Compounds/PermissibleRender';
import { Permission } from '../../../store/GeneralStore';
import { PageCard } from '../../Compounds/CardWithTitle';
import { useProductsStore } from '../../../store/Product';
import { BulkInventoryForm } from '../../Compounds/BulkInventoryUpload/BulkInventoryForm';
import { InvoiceParserForm } from '../../Compounds/InvoiceParserForm/InvoiceParserForm';

export const AddInventoryPage = () => {
  const { fetchProducts } = useProductsStore();

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <PageLayout
      pageTitle="Add Inventory"
      className="max-w-[98vw]">
      <TextBlock size="md">Manage inventory not currently in UPSTACK, by adding it to the portal.</TextBlock>
      <>
        <PermissibleRender requiredPermissions={[Permission.PARSE_INVOICE]}>
          <PageCard title="Invoice Parser">
            <InvoiceParserForm />
          </PageCard>
        </PermissibleRender>
        <PermissibleRender requiredPermissions={[Permission.BULK_OUTSIDE_INVENTORY]}>
          <>
            <PageCard title="Bulk Upload">
              <BulkInventoryForm />
            </PageCard>
          </>
        </PermissibleRender>
        <PageCard
          title="Add Manually"
          enableCollapse={false}>
          <OutsideInventoryBulkManualForm />
        </PageCard>
      </>
    </PageLayout>
  );
};
